export default __webpack_public_path__ + "static/media/(31).842bfe04.jpg";